const networkList = [
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: 'MTV 물류센터',
        goods: '일반, 보세, 항온항습, 헬스케어',
        address: '경기도 안산시 단원구 엠티브이6로18번길 23',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '남청라 물류센터',
        goods: '일반',
        address: '인천광역시 서구 북항로 28-23 남청라센터',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '남청라2 물류센터',
        goods: '일반',
        address: '인천광역시 서구 건지로 45',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '북청라 물류센터',
        goods: '일반',
        address: '인천광역시 서구 정서진로 47',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '인천신항 물류센터',
        goods: '일반, 고객사전용',
        address: '인천광역시 연수구 인천신항대로 866-7',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '인천공항 물류센터',
        goods: '일반, 수출입, 보세, 냉장냉동, 헬스케어',
        address: '인천광역시 중구 공항동로 296번길 98-30 ',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '영종 물류센터',
        goods: '일반, 보세, 항온항습, 고객사전용',
        address: '인천광역시 중구 영종순환로 900번길 30',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '남이천 물류센터',
        goods: '일반, 고객사전용',
        address: '경기도 이천시 대월면 대월로 256',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '서이천 물류센터',
        goods: '일반, 항온항습, 냉장냉동, 헬스케어',
        address: '경기도 이천시 마장면 프리미엄아울렛로 113-60 A동',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '북이천 물류센터',
        goods: '일반, 고객사전용',
        address: '경기도 이천시 백사면 이여로 501 ',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '이천2 물류센터',
        goods: '일반, 고객사전용',
        address: '경기도 이천시 진상미로 1894',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '지마켓동탄 물류센터',
        goods: '일반, 고객사전용',
        address: '경기도 화성시 동탄물류로 48 3층 3R',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '평택 물류센터',
        goods: '일반, 보세, 항온항습, 냉장냉동, 헬스케어',
        address: '경기도 평택시 진위면 서탄로33',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '평택위험물 물류센터',
        goods: '위험물',
        address: '경기도 평택시 청북읍 원한산길 139',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '평택 HUB',
        goods: '보세, 고객사전용',
        address: '경기도 평택시 진위면 LG로 222 HE연구동(R1동) 1층',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '용인맹리 물류센터',
        goods: '일반',
        address: '경기도 용인시 처인구 맹리로 2번길 1',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '물류센터',
        name: '안성 물류센터',
        goods: '일반, 항온항습, 냉장냉동, 헬스케어',
        address: '경기도 안성시 삼죽면 삼죽로 75',
    },
    {
        area: '중부권',
        category: '물류센터',
        name: '음성 물류센터',
        goods: '일반, 고객사전용',
        address: '충청북도 음성군 삼성면 천평길 68 3층 ',
    },
    {
        area: '중부권',
        category: '물류센터',
        name: '천안 물류센터',
        goods: '일반, 고객사전용',
        address: '충청남도 천안시 동남구 풍세면 풍세산단3로 111',
    },
    {
        area: '중부권',
        category: '물류센터',
        name: '천안2 물류센터',
        goods: '일반, 고객사전용',
        address: '충청남도 천안시 동남구 성남면 대흥1길 122',
    },
    {
        area: '호남권',
        category: '물류센터',
        name: '광주 물류센터',
        goods: '일반, 보세',
        address: '광주광역시 광산구 평동산단7번로 108',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '울산 물류센터',
        goods: '위험물',
        address: '울산광역시 남구 신항로 716번길 60 ',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '창원 HUB',
        goods: '보세, 고객사전용',
        address: '경상남도 김해시 유하로59번길5',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '구미 HUB',
        goods: '보세, 고객사전용',
        address: '경상북도 구미시 산호대로 377',
    },
    {
        area: '경상권',
        category: '타 사업부',
        name: '구미 CY&CFS',
        goods: '일반',
        address: '경상북도 구미시 산동읍 임천인덕로 204',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '밀양 물류센터',
        goods: '일반, 고객사전용',
        address: '경상남도 밀양시 부북면 사포로 91',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '진주 물류센터',
        goods: '일반, 고객사전용',
        address: '경상남도 진주시 지수면 용봉로 130',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '부산2 물류센터',
        goods: '일반, 고객사전용',
        address: '경상남도 창원시 진해구 신항8로 343',
    },
    {
        area: '경상권',
        category: '물류센터',
        name: '부산신항 물류센터',
        goods: '일반, 수출입, 보세, 항온항습, 위험물, 헬스케어',
        address: '경상남도 창원시 진해구 신항4로 15-85 2층',
    },
    {
        area: '제주권',
        category: '물류센터',
        name: '제주 물류센터',
        goods: '일반, 고객사전용',
        address: '제주특별자치도 제주시 구좌읍 일주동로 2706-27',
    },
    {
        area: '수도권(동부, 서부, 남부)',
        category: '운송센터',
        name: '안양 운송센터',
        goods: '',
        address: '경기도 안양시 만안구 덕천로 48 3층',
    },
    {
        area: '경상권',
        category: '운송센터',
        name: '구미 운송센터',
        goods: '',
        address: '경상북도 구미시 비산로 89',
    },
    {
        area: '경상권',
        category: '운송센터',
        name: '창원 운송센터',
        goods: '',
        address: '경상남도 창원시 의창구 차상로 96',
    },
    {
        area: '호남권',
        category: '운송센터',
        name: '나주 운송센터',
        goods: '',
        address: '전라남도 나주시 건재로 278 관리동 208호',
    },
    {
        area: '호남권',
        category: '운송센터',
        name: '여수 운송센터',
        goods: '',
        address: '전라남도 여수시 좌수영로 532',
    },
    {
        area: '호남권',
        category: '운송센터',
        name: '전주 운송센터',
        goods: '',
        address: '전라북도 전주시 덕진구 진버들3길 21-12 7층',
    },
    {
        area: '중부권',
        category: '운송센터',
        name: '대산 운송센터',
        goods: '',
        address: '충청남도 서산시 대산읍 명지1로 238 2층',
    },
    {
        area: '중부권',
        category: '운송센터',
        name: '천안 운송센터',
        goods: '',
        address: '충청남도 천안시 서북구 입장면 연곡길 387',
    },
    {
        area: '중부권',
        category: '운송센터',
        name: '청주 운송센터',
        goods: '',
        address: '충청북도 청주시 흥덕구 직지대로 240번길 72',
    },
    {
        area: '경상권',
        category: '운송센터',
        name: '부산 운송센터',
        goods: '',
        address: '부산광역시 중구 충장대로 9번길 46 관정빌딩 16층',
    },
    {
        area: '경상권',
        category: '운송센터',
        name: '울산 운송센터',
        goods: '',
        address: '울산광역시 남구 온산로 835',
    },
];
